export default "__VITE_ASSET__BoAnjGID__"